import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CopyUserService {

    private copyUserId$?: Observable<any>;

    constructor(
        private http: HttpClient
    ) {}

    getCopyUserId(): Observable<any> {
        if (!this.copyUserId$) {
            const body = { type: 1 };
            this.copyUserId$ = this.http.post<any>('/comm_fn.php', body).pipe(
                map(res => res.status ? res.data : null),
                shareReplay(1)
            );
        }
        return this.copyUserId$;
    }

    refresh(): void {
        this.copyUserId$ = undefined;
    }
}
